import { FC } from 'react';

import Table from 'modules/_shared/Table';

import HoldingClassTableHeader from './HoldingClassTableHeader';
import HoldingClassTableBody from './HoldingClassTableBody';

const HoldingClassTable: FC = () => {
  const tableContent = (
    <>
      <HoldingClassTableHeader />
      <HoldingClassTableBody />
    </>
  );

  return (
    <div className="card card-bordered card-preview">
      <div className="table-responsive">
        <Table content={tableContent} />
      </div>
    </div>
  );
};

export default HoldingClassTable;
